import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Wrapper = styled.div(
  ({
    align,
    noMargin,
  }: {
    align: 'left' | 'center' | 'right'
    noMargin: boolean
  }) => css`
    display: flex;
    align-items: center;
    justify-content: ${(align === 'right' && 'flex-end') ||
    (align === 'center' && 'center') ||
    'flex-start'};
    text-align: ${align || 'left'};
    gap: 5px;
    margin: ${noMargin ? 'unset' : '0.5em 0'};
  `
)
